module.exports = __webpack_public_path__ + "fonts/Inter-Regular-slnt=0.515cae74.ttf";